module.exports = __webpack_public_path__ + "img/gato.e5f77a5e.png";